import React, { useEffect, useRef } from 'react';

interface CaptchaProps {
  siteKey: string;
  onVerify: (token: string) => void;
  onError?: () => void;
  theme?: 'light' | 'dark';
  size?: 'normal' | 'compact';
}

declare global {
  interface Window {
    hcaptcha: any;
  }
}

export const Captcha: React.FC<CaptchaProps> = ({
  siteKey,
  onVerify,
  onError,
  theme = 'light',
  size = 'normal'
}) => {
  const captchaRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.hcaptcha.com/1/api.js?onload=onHCaptchaLoaded&render=explicit';
    script.async = true;
    
    (window as any).onHCaptchaLoaded = () => {
      if (captchaRef.current && window.hcaptcha) {
        window.hcaptcha.render(captchaRef.current, {
          sitekey: siteKey,
          theme,
          size,
          callback: onVerify,
          'error-callback': onError
        });
      }
    };

    document.head.appendChild(script);
    
    return () => {
      document.head.removeChild(script);
      delete (window as any).onHCaptchaLoaded;
    };
  }, [siteKey, theme, size, onVerify, onError]);

  return <div ref={captchaRef} />;
};

export default Captcha; 